import React, { useEffect, useState } from 'react';
import { useIntl, FormattedMessage } from 'react-intl';

import CustomBtn from '../../../../../../generic/CustomBtn';
import Loader from '../../../../../../components/Loader';
import RequestModal from '../../../../../../components/RequestModal';
import { ReactComponent as TreeGroup } from '../../../../../../assets/image/carbon/tree-group.svg';
import './CarbonNotAvailable.scss';

import getConfig from '../../../../../../config';
import { sendRequest, handleResponseStatus } from '../../../../../../utils/api-request';

const { backendApi } = getConfig();

const CarbonNotAvailable = ({ projectId }) => {
  const translate = useIntl();
  const [isInterested, setIsInterested] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);

  const getIsInterested = async () => {
    setIsLoading(true);

    const { result, statusCode } = await sendRequest(`${backendApi}/api/dashboard/get-carbon-form?project_id=${projectId}`, 'GET', {}, true);
    handleResponseStatus(
      statusCode,
      () => setIsInterested(!!result?.isInterest),
      () => setIsError(true),
    );

    setIsLoading(false);
  };

  const postIsInterested = async () => {
    setIsLoading(true);

    const body = JSON.stringify({ isInterest: true, project_id: projectId });

    const { statusCode } = await sendRequest(`${backendApi}/api/dashboard/save-is-interest-carbon`, 'POST', body, true);
    handleResponseStatus(
      statusCode,
      () => setIsInterested(true),
      () => setIsError(true),
    );

    setIsLoading(false);
  };

  useEffect(() => {
    getIsInterested();
  }, []);

  return (
    <div className="carbon-not-available">
      {isError && (
        <RequestModal
          error
          handleClose={() => setIsError(false)}
          title={translate.formatMessage({ id: 'modal.title.oops' })}
          description={(
            <FormattedMessage
              id="modal.description.somethingGoesWrong"
              values={{
                link: (...chunks) => <a href="mailto:support@openforestprotocol.org" className="text-anchor">{chunks}</a>,
              }}
            />
)}
        />
      )}
      {isLoading ? (
        <div className="carbon-not-available__loader-wrapper">
          <Loader viewType="leaves-spinner" />
        </div>
      ) : isInterested ? (
        <>
          <p className="carbon-not-available__title">{translate.formatMessage({ id: 'carbon.notAvailable.thankYouForSharing' })}</p>
          <div className="carbon-not-available__image">
            <TreeGroup />
          </div>
        </>
      ) : (
        <>
          <p className="carbon-not-available__title">
            <FormattedMessage
              id="carbon.notAvailable.financingIsNotAvailable"
              values={{ br: <br /> }}
            />
          </p>
          <div className="carbon-not-available__image">
            <TreeGroup />
          </div>
          <div className="carbon-not-available__button-wrapper">
            <CustomBtn
              label={translate.formatMessage({ id: 'button-imInterested' })}
              handleClick={() => postIsInterested()}
              type="button"
              customClass="carbon-not-available__button"
            />
          </div>
        </>
      )}
    </div>
  );
};

export default CarbonNotAvailable;
